// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__2StDK","image":"header_image__37ltx","card":"header_card__pV6Sj","title":"header_title__hy2WN","description":"header_description__1Vdzj"};